/* eslint-disable no-underscore-dangle, react/no-danger, import/no-extraneous-dependencies */
import getBaseUrl from "lib/utils/getBaseUrl";
import Head from "next/head";

export default function FundamenteiAppHead() {
  return (
    <Head>
      <title>Fundamentei</title>

      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" key="viewport" />

      <meta name="robots" content="index,follow" />
      <meta name="title" content="Fundamentei" key="title" />
      <meta
        name="description"
        content="Site completo de Análise Fundamentalista de Ações, Stocks e Fundos Imobiliários"
        key="description"
      />

      <meta name="og:type" property="og:type" content="website" />
      <meta name="og:site_name" property="og:site_name" content="Fundamentei" key="og:site_name" />
      <meta name="og:title" property="og:title" content="Fundamentei" key="og:title" />
      <meta
        name="og:description"
        property="og:description"
        content="Site completo de Análise Fundamentalista de Ações, Stocks e Fundos Imobiliários"
        key="og:description"
      />
      <meta
        name="og:image"
        property="og:image"
        content={`${getBaseUrl()}/static/branding/wordmark/White on Blue@4x.jpg`}
      />
      <meta name="og:image:type" property="og:image:type" content="image/jpg" />
      <meta name="og:image:width" property="og:image:width" content="3344" />
      <meta name="og:image:height" property="og:image:height" content="976" />
      <meta name="og:locale" property="og:locale" content="pt_BR" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@fundamentei" />
      <meta name="twitter:title" content="Fundamentei" />
      <meta name="twitter:image" content={`${getBaseUrl()}/static/branding/wordmark/White on Blue@4x.jpg`} />
      <meta name="twitter:image:alt" content="Logotipo do Fundamentei" />

      <link rel="canonical" href={getBaseUrl()} key="canonical" />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            name: "Fundamentei",
            url: getBaseUrl(),
            logo: `${getBaseUrl()}/static/branding/symbol/White on Blue@4x.jpg`,
            sameAs: [
              "https://instagram.com/fundamentei",
              "https://twitter.com/fundamentei",
              "https://medium.com/@fundamentei",
              "https://github.com/fundamentei",
              "https://www.youtube.com/channel/UC72WcGU4HpVposjNHlP3FRg",
              "https://www.linkedin.com/company/fundamentei",
            ],
            contactPoint: [
              {
                "@type": "ContactPoint",
                email: "contato@fundamentei.com",
                url: getBaseUrl(),
                contactType: "customer support",
                areaServed: ["BR"],
                availableLanguage: ["Portuguese", "English"],
              },
            ],
          }),
        }}
      />
    </Head>
  );
}
